import axios from 'axios';

export const reportTotalBranchData = (branchID, month, area, token) => {
    const areaParam = encodeURIComponent(area || '');
    let newURL = `/report/${branchID}/take_guest_number/${month}/${areaParam}/report`
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
}

export const reportTotalBranchData2 = (branchID, month, area, type, token) => {
    const areaParam = encodeURIComponent(area || '');
    let newURL = `/report/${branchID}/take_guest_number/${month}/${areaParam}/${type}`
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
}

export const reportTotalAreaData = (branchID, month, area, token) => {
    const areaParam = encodeURIComponent(area || '');
    let newURL = `/report/${branchID}/take_guest_number_area/${month}/${areaParam}/report`
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
}

export const reportTotalMembership = (token) => {
    let newURL = `/report/membership`
    return axios.get(`${newURL}`, {
        headers: { Authorization: token }
    });
}

// export const checkCaptianTwoMonth = (branchID, month1, month2, token) => {
//     let newURL = `http://localhost:5600/report/${branchID}/check_capacity_two_month/two/${month1}/${month2}`
//     //let newURL = `http://database.azumayareport.com/report/${branchID}/check_capacity_two_month/two/${month1}/${month2}`

//     return axios.get(`${newURL}`, {
//         headers: { Authorization: token }
//     });
// }

// export const checkCaptianOneMonth = (branchID, month, token) => {
//     let newURL = `http://localhost:5600/report/${branchID}/check_capacity_two_month/one/${month}`;
//     //let newURL = `http://database.azumayareport.com/report/${branchID}/check_capacity_two_month/one/${month}`;
//     return axios.get(`${newURL}`, {
//         headers: { Authorization: token }
//     });
// }